const API_BASE = process.env.REACT_APP_API_URL || '';

export async function getArtifacts(orgId, filters = {}) {
  const params = new URLSearchParams();
  if (filters.category) params.append('category', filters.category);
  if (filters.tag) params.append('tag', filters.tag);
  if (filters.search) params.append('search', filters.search);
  if (filters.limit) params.append('limit', filters.limit.toString());
  if (filters.offset) params.append('offset', filters.offset.toString());
  
  const queryString = params.toString();
  const url = `${API_BASE}/orgs/${orgId}/artifacts${queryString ? '?' + queryString : ''}`;
  
  const response = await fetch(url, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch artifacts');
  }
  
  return response.json();
}

export async function getArtifact(orgId, artifactId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/artifacts/${artifactId}`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    if (response.status === 404) {
      return null;
    }
    throw new Error('Failed to fetch artifact');
  }
  
  const data = await response.json();
  return data.artifact;
}

export async function getCategories(orgId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/artifacts/categories`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch categories');
  }
  
  const data = await response.json();
  return data.categories;
}

export async function getDownloadUrl(orgId, artifactId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/artifacts/${artifactId}/download`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to get download URL');
  }
  
  return response.json();
}

export async function downloadArtifact(orgId, artifactId) {
  const signedUrl = await getDownloadUrl(orgId, artifactId);
  
  const response = await fetch(`${API_BASE}${signedUrl.url}`, {
    credentials: 'include'
  });
  
  if (!response.ok) {
    throw new Error('Failed to download artifact');
  }
  
  return response.json();
}
